import React from 'react';

type SendIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function SendIcon({ onClick, className = '' }: SendIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M18.7793 1.21876C18.5674 1.00782 18.252 0.943371 17.9746 1.05274L1.47462 7.56153C1.20509 7.667 1.0215 7.91993 1.00196 8.20899C0.982421 8.49805 1.13087 8.77247 1.3838 8.91309L7.63868 12.4082L11.1602 18.6201C11.294 18.8555 11.544 19 11.8125 19C11.8301 19 11.8486 18.999 11.8662 18.9981C12.1553 18.9775 12.4063 18.792 12.5107 18.5225L18.9483 2.02247C19.0567 1.74513 18.9903 1.42872 18.7793 1.21876ZM15.1691 3.77149L8.05616 10.9231L3.49708 8.37598L15.1691 3.77149ZM11.6875 16.5078L9.1211 11.9812L16.2495 4.81397L11.6875 16.5078Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SendIcon;
